module.exports = __webpack_public_path__ + "bin/9f8709a165d5ba82fd1b144b8807508d.jpg";